export const BigButton = ({ className }) => (
  <svg
    className={className}
    width='185'
    height='185'
    viewBox='0 0 185 185'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <g filter='url(#filter0_i_38_23)'>
      <rect x='0.700439' y='0.396606' width='184' height='184' rx='92' fill='#FFD500' />
      <rect x='0.700439' y='0.396606' width='184' height='184' rx='92' fill='url(#paint0_linear_38_23)' />
      <path
        d='M30.2084 98.8966V86.8966H38.9924C41.8404 86.8966 43.4084 88.1286 43.4084 90.0486C43.4084 91.5366 42.4164 92.5926 40.6404 92.7366C42.6404 92.7686 43.8564 94.0166 43.8564 95.7606C43.8564 97.6806 42.4004 98.8966 39.7284 98.8966H30.2084ZM37.6644 91.6966C38.8484 91.6966 39.4564 91.3606 39.4564 90.5606C39.4564 89.6966 38.8324 89.3446 37.6004 89.3446H33.9684V91.6966H37.6644ZM38.4484 96.4166C39.3604 96.4166 39.9044 96.0486 39.9044 95.2486C39.9044 94.3686 39.1684 93.9686 37.7284 93.9686H33.9684V96.4166H38.4484ZM55.7182 89.8406V98.8966H52.1342V96.7686C51.4462 98.4966 50.0862 99.2646 48.3902 99.2646C46.1982 99.2646 45.0142 98.0326 45.0142 95.6486V89.8406H48.7742V94.9446C48.7742 95.9526 49.3342 96.4966 50.2462 96.4966C50.9342 96.4966 51.5422 96.1606 51.9582 95.4406V89.8406H55.7182ZM56.7049 89.8406H60.8169L63.3929 96.0486L65.6009 89.8406H69.5369L65.5049 98.8486C64.2729 101.601 62.4009 102.769 59.5369 102.769C58.5289 102.769 57.7449 102.625 57.0409 102.417L56.9449 99.8246C57.4729 99.9366 58.0649 100.049 58.7849 100.049C60.0649 100.049 60.8329 99.6646 61.0889 98.7206L56.7049 89.8406ZM75.4643 89.9686V86.8966H88.5523V89.9686H83.9763V98.8966H80.0563V89.9686H75.4643ZM89.9536 89.8406H93.7296V98.8966H89.9536V89.8406ZM90.0496 86.0166H93.6496V88.7686H90.0496V86.0166ZM100.993 89.5046C102.257 89.5046 103.585 89.7286 104.833 90.2886L104.913 92.8166C103.921 92.3526 102.865 92.1446 101.825 92.1446C99.9369 92.1446 98.8809 92.8966 98.8809 94.2566C98.8809 95.6646 100.017 96.4806 102.081 96.4806C103.153 96.4806 104.257 96.2566 105.089 95.8406L104.929 98.5126C103.809 99.0406 102.593 99.2646 101.137 99.2646C97.2009 99.2646 94.9609 97.4246 94.9609 94.4646C94.9609 91.3606 97.2169 89.5046 100.993 89.5046ZM106.358 86.1926H110.118V92.6406L113.558 89.8406H118.15L113.59 93.4566L118.55 98.8966H114.166L111.126 95.4086L110.118 96.2086V98.8966H106.358V86.1926ZM117.914 94.4326C117.914 91.3606 120.106 89.4886 123.722 89.4886C126.874 89.4886 128.938 91.2006 128.938 93.8566V95.0086H121.562C121.946 96.2086 123.13 96.8486 125.066 96.8486C126.282 96.8486 127.626 96.6086 128.922 96.2086L128.746 98.4966C127.53 98.9766 126.186 99.2646 124.49 99.2646C120.378 99.2646 117.914 97.4406 117.914 94.4326ZM125.354 93.5686C125.322 92.4166 124.682 91.7606 123.498 91.7606C122.282 91.7606 121.562 92.4326 121.53 93.5686H125.354ZM131.291 95.6966V92.3686H129.707V89.8406H131.355V88.3526L134.955 86.7206V89.8406H138.843V92.3686H134.955V94.5446C134.955 96.0166 135.899 96.6406 137.467 96.6406C138.011 96.6406 138.635 96.5766 139.291 96.3686L138.907 98.7526C138.011 99.0886 136.923 99.2646 135.899 99.2646C133.179 99.2646 131.291 98.0006 131.291 95.6966ZM154.729 95.6486L145.625 98.7366V95.9526L151.673 94.0806L145.625 92.3206V89.5686L154.729 92.4966V95.6486Z'
        fill='url(#paint1_linear_38_23)'
      />
    </g>
    <defs>
      <filter
        id='filter0_i_38_23'
        x='0.700439'
        y='0.396606'
        width='184'
        height='184'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='-9' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix type='matrix' values='0 0 0 0 0.2125 0 0 0 0 0.0797033 0 0 0 0 0.0115104 0 0 0 0.42 0' />
        <feBlend mode='normal' in2='shape' result='effect1_innerShadow_38_23' />
      </filter>
      <linearGradient
        id='paint0_linear_38_23'
        x1='92.7004'
        y1='184.397'
        x2='92.7004'
        y2='0.396606'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#F99D00' />
        <stop offset='1' stopColor='#FFD500' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_38_23'
        x1='92.7004'
        y1='79.8966'
        x2='92.7004'
        y2='104.897'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#01A6E4' />
        <stop offset='1' stopColor='#0E60A7' />
      </linearGradient>
    </defs>
  </svg>
);
